import type { Driver } from '#domain/Driver.ts';
import type { Vehicle } from '#domain/Vehicle.ts';
import { apiV2Root } from '#store/apiV2Root.ts';

import { mapDrivers, mapVehicles } from './adapters/resourcesAdapter.ts';
import { apiSchema } from './model/types.ts';
import { validateWarn } from './validateZodHelper.ts';

export const resourcesSlice = apiV2Root.injectEndpoints({
    endpoints: build => ({
        getDrivers: build.query<Driver[], void>({
            query: () => '/resources/drivers',
            providesTags: ['DRIVERS'],
            transformResponse: (response, meta, arg) =>
                mapDrivers(validateWarn(apiSchema.Driver.array())(response, meta, arg)),
        }),
        getVehicles: build.query<Vehicle[], void>({
            query: () => '/resources/vehicles',
            providesTags: ['VEHICLES'],
            transformResponse: (response, meta, arg) =>
                mapVehicles(validateWarn(apiSchema.Vehicle.array())(response, meta, arg)),
        }),
    }),
});

export const { useGetDriversQuery, useGetVehiclesQuery } = resourcesSlice;

export const useResources = () => {
    const { data: drivers, isLoading: driverLoading, refetch: refetchDrivers } = useGetDriversQuery();
    const { data: vehicles, isLoading: vehicleLoading, refetch: refetchVehicles } = useGetVehiclesQuery();

    return {
        isLoading: driverLoading || vehicleLoading,
        drivers: drivers || [],
        vehicles: vehicles || [],
        refetch: () => {
            refetchDrivers();
            refetchVehicles();
        },
    };
};
